"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("../../utils/helpers");
var _settings = require("./../../settings");
var _SlideModule = _interopRequireDefault(require("./../../scss/carousels/Slide.module.scss"));
function CarouselSlide(_ref) {
  let {
    slide,
    index,
    currentIndex,
    variableHeight = false
  } = _ref;
  const [Layout, setLayout] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    // load the layout component used for this slide
    setLayout(_settings.slideLayoutsMap.get(slide.layout));
  }, [slide]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _helpers.classes)([_SlideModule.default['slide'], 'slide', variableHeight ? _SlideModule.default['slide--variable-height'] : '']),
    "aria-label": slide.ariaLabel,
    "aria-roledescription": "carousel-item",
    inert: currentIndex !== index ? "" : null,
    "data-index": index
  }, Layout !== null && slide.cells.map((cell, i) => {
    return /*#__PURE__*/_react.default.createElement(Layout, (0, _extends2.default)({}, cell.props, {
      key: "slide".concat(index, "-cell").concat(i)
    }));
  })));
}
var _default = exports.default = CarouselSlide;